import { Typography } from "antd";

import { Box } from "~/src/components/box";
import { Container } from "~/src/components/container";

const getTextParagraphs = (text: string) => {
  return text.split(/\n{2,}/);
};

type Props = {
  id?: string;
  title: string;
  text: string;
};

export const TextBlock = ({ title, text, id }: Props) => {
  const paragraphs = getTextParagraphs(text);

  return (
    <Box paddingVertical="sm" paddingHorizontal="lg">
      <Container width="sm" id={id}>
        <Typography>
          {title ? <h4>{title}</h4> : null}
          {paragraphs.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </Typography>
      </Container>
    </Box>
  );
};
